<dojo-master-list-view
  [searchPlaceholder]="'Search reference questions'"
  [columnDefs]="columnDefs"
  [gridOptions]="gridOptions"
  [canAdd]="false"
  [showToolbarAddButton]="true"
  (add)="addReferenceQuestion()"
  (gridRowClicked)="openReferenceQuestion($event)"
  (gridReady)="onGridReady($event)"
  [hideSearch]="true"
  [agGridAdditionalClass]="'small-height'"
  [@appearOnTrigger]="!isLoading()"
/>

@if (isLoading()) {
  <div class="absolute left-0 top-0 flex h-full w-full items-center justify-center">
    <dojo-loader />
  </div>
}
